import AmountOption from "../../components/AmountOption/AmountOption";
import { amountChoice } from "../../app/voucherSlice";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import PurchaseFlowHeader from "../../layout/PurchaseFlowHeader/PurchaseFlowHeader";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ChooseAmount = () => {
    const { t } = useTranslation();

    const chosenMerchant = useAppSelector(
        state => state.voucher.chosenMerchant
    );
    const dispatch = useAppDispatch();

    const selectAmount = (voucher: { guid: string; amount: number }) => {
        dispatch(amountChoice(voucher));
    };

    if (!chosenMerchant.id) return <Redirect to={"/"} />;

    return (
        <section className="container first-section">
            <div className="purchase-container">
                <PurchaseFlowHeader header={t("amount.title")} />
                {chosenMerchant.vouchers.map(voucher => (
                    <AmountOption
                        key={voucher.guid}
                        merchantClass={chosenMerchant.classAppend}
                        logo={chosenMerchant.logo}
                        name={chosenMerchant.name}
                        amount={voucher.amount}
                        count={voucher.count}
                        onChooseAmount={() =>
                            selectAmount({
                                guid: voucher.guid,
                                amount: voucher.amount
                            })
                        }
                    />
                ))}
            </div>
        </section>
    );
};

export default ChooseAmount;
